import moment from 'moment';

const defaultPaginationSize = 20;

class Search {
  constructor(appAPI, appRequestsCache, appUtils) {
    'inject';

    this._appAPI = appAPI;
    this._appRequestsCache = appRequestsCache;
    this._appUtils = appUtils;
    this._allEventsItems = {
      id: '---all-events',
      name: 'All',
      description: 'All the different type of events',
    };
  }
  getSettings() {
    return this._appRequestsCache.save('search.settings', () => (
      this._appAPI.getSearchSettings()
      .then((settings) => {
        const typesByProperty = {};
        const fieldsByProperty = {};
        const properties = Object.keys(settings.properties)
        .map((key) => {
          const {
            id,
            name,
            description,
            types,
            fields,
          } = settings.properties[key];
          typesByProperty[id] = types
          .map((type) => Object.assign({}, type, {
            description: this._shortenDescription(type.description),
          }))
          .sort(this._appUtils.sortObjectsList('name'));
          fieldsByProperty[id] = fields;

          return {
            id,
            name,
            description: this._shortenDescription(description),
          };
        })
        .sort(this._appUtils.sortObjectsList('name'));

        return {
          typesByProperty,
          fieldsByProperty,
          properties,
          events: [
            this._allEventsItems,
            ...settings.events,
          ],
        };
      })
    ));
  }
  search(event, rules, dateRange = null, page = 1, itemsPerPage = defaultPaginationSize) {
    return this.getSettings()
    .then((settings) => {
      const query = {};
      if (event.id !== this._allEventsItems.id) {
        query.event = {
          name: event.name.toLowerCase(),
        };
      }

      rules.forEach((rule) => {
        const property = {};
        const fields = settings.fieldsByProperty[rule.property.id];
        if (fields.type) {
          property[fields.type] = rule.type.name.toLowerCase();
        }

        if (fields.value) {
          property[fields.value] = rule.value;
        }

        query[rule.property.name] = property;
      });

      if (dateRange) {
        const millisecondsOnASecond = 1000;
        const end = moment(dateRange.to)
        .add(1, 'day')
        .startOf('day')
        .format('X');
        query.published = {
          begin: Math.round(dateRange.from.getTime() / millisecondsOnASecond),
          end: Math.floor(end),
        };
      }

      return this._appAPI.search(query, page, itemsPerPage);
    })
    .then(({ count: total, activities }) => ({
      total,
      activities,
    }));
  }
  _shortenDescription(description) {
    return description.includes('.') ?
      `${description.split('.').shift()}.` :
      description;
  }
}

export { Search };
